function buildMaybePartnerRouteWithCurrentRoute(location, currentRoute) {
    const { partnerName } = currentRoute.params;
    const urlPrefix = partnerName ? `/${partnerName}` : '';
    if (typeof location === 'string') {
        return `${urlPrefix}${location}`;
    }
    const newLocation = {
        ...location,
        params: {
            ...location.params,
            partnerName: partnerName !== null && partnerName !== void 0 ? partnerName : null,
        },
    };
    if (location.path !== undefined) {
        newLocation.path = `${urlPrefix}${location.path}`;
    }
    return newLocation;
}
const getMatchedMeta = (route) => route.matched.reduce((previousMeta, matched) => ({
    ...previousMeta,
    ...matched.meta,
}), {});

export { buildMaybePartnerRouteWithCurrentRoute, getMatchedMeta };
